import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dc5bba5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "com_form_contet1"
}
const _hoisted_2 = { class: "com_sec1" }
const _hoisted_3 = { class: "inner1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title_left" }, "管理者TOP", -1))
const _hoisted_5 = {
  key: 0,
  class: "error-message"
}
const _hoisted_6 = {
  key: 1,
  class: "error-message"
}
const _hoisted_7 = { class: "columns" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  class: "agent-buttons",
  style: {"width":"550px"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "エージェントコード切替", -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  class: "agent-buttons",
  style: {"width":"550px"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "営業日切替", -1))
const _hoisted_14 = ["max"]
const _hoisted_15 = { class: "columns" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  class: "agent-buttons",
  style: {"width":"550px"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "ユーザー管理", -1))
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  class: "agent-buttons",
  style: {"width":"550px"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "お知らせ管理", -1))
const _hoisted_22 = { key: 2 }
const _hoisted_23 = {
  class: "agent-buttons",
  style: {"width":"1120px"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "システム管理", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = { key: 3 }
const _hoisted_27 = {
  class: "agent-buttons",
  style: {"width":"1120px"}
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "ワンストップガイド管理", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = { key: 4 }
const _hoisted_31 = {
  class: "agent-buttons",
  style: {"width":"800px"}
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "スキルアップ管理", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_loading_overlay = _resolveComponent("loading-overlay")!
  const _component_AlphanumericInput = _resolveComponent("AlphanumericInput")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, {
        "external-pseudo-agent-code": _ctx.pseudoAgCode,
        "external-pseudo-agent-name": _ctx.pseudoAgName,
        isAdminPage: true
      }, null, 8, ["external-pseudo-agent-code", "external-pseudo-agent-name"])
    ]),
    _createVNode(_component_loading_overlay, {
      active: _ctx.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
      "is-full-page": true
    }, null, 8, ["active"]),
    (_ctx.isDataFetched)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("section", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              (_ctx.formErrorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.formErrorMessage), 1))
                : _createCommentVNode("", true),
              (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.isKaunetAdmin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("fieldset", _hoisted_9, [
                        _hoisted_10,
                        _createVNode(_component_AlphanumericInput, {
                          modelValue: _ctx.inputAgCode,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputAgCode) = $event)),
                          maxlength: "8",
                          placeholder: "エージェントコード"
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("button", {
                          type: "button",
                          name: "btnPseudoLogin",
                          class: "button1",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.pseudoLogin && _ctx.pseudoLogin(...args)))
                        }, " 切替 "),
                        _createElementVNode("button", {
                          type: "button",
                          name: "btnPseudoLoginCancel",
                          class: "button1",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.pseudoLoginCancel && _ctx.pseudoLoginCancel(...args)))
                        }, " 解除 ")
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isKaunetAdmin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("fieldset", _hoisted_12, [
                        _hoisted_13,
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputBusinessDays) = $event)),
                          max: _ctx.AppConstants.MAX_DATE_VALUE
                        }, null, 8, _hoisted_14), [
                          [_vModelText, _ctx.inputBusinessDays]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "button1",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.chengeBuisinessDate && _ctx.chengeBuisinessDate(...args)))
                        }, " 切替 "),
                        _createElementVNode("button", {
                          type: "button",
                          class: "button1",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clearBuisinessDate && _ctx.clearBuisinessDate(...args)))
                        }, " 解除 ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                (_ctx.isDispAgSegmentReg || _ctx.isDispAgUserMaintenance)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("fieldset", _hoisted_17, [
                        _hoisted_18,
                        (_ctx.isDispAgSegmentReg)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              name: "btnLogout",
                              class: "button2",
                              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.agSegmentReg && _ctx.agSegmentReg(...args)))
                            }, " AGセグメント登録 "))
                          : _createCommentVNode("", true),
                        (_ctx.isDispAgUserMaintenance)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              name: "btnLogout",
                              class: "button2",
                              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.userMaintenance && _ctx.userMaintenance(...args)))
                            }, " ユーザー情報管理 "))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isDispNoticeReg || _ctx.isKaunetAdmin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("fieldset", _hoisted_20, [
                        _hoisted_21,
                        (_ctx.isDispNoticeReg)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              name: "btnLogout",
                              class: "button2",
                              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.infoReg && _ctx.infoReg(...args)))
                            }, " お知らせ登録 "))
                          : _createCommentVNode("", true),
                        (_ctx.isKaunetAdmin)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              name: "btnLogout",
                              class: "button2",
                              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.adminInfoReg && _ctx.adminInfoReg(...args)))
                            }, " 管理者からのお知らせ登録 "))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isDispSystemMaintenance && _ctx.isKaunetAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("fieldset", _hoisted_23, [
                      _hoisted_24,
                      (_ctx.isDispGlovalNaviKanri)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            name: "btnGrovalNavi",
                            class: "button2",
                            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.globalNaviKanri && _ctx.globalNaviKanri(...args)))
                          }, " グローバルナビ管理 "))
                        : _createCommentVNode("", true),
                      (_ctx.isDispIconMenuKanri)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            name: "btnIconMenu",
                            class: "button2",
                            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.iconMenuKanri && _ctx.iconMenuKanri(...args)))
                          }, " アイコンメニュー管理 "))
                        : _createCommentVNode("", true),
                      (_ctx.isDispLoginPopupKanri)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            name: "btnLoginPopup",
                            class: "button2",
                            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.loginPopupTouroku && _ctx.loginPopupTouroku(...args)))
                          }, [
                            _createTextVNode(" ログイン時ポップアップ"),
                            _hoisted_25,
                            _createTextVNode("管理 ")
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isDispBannerKanri)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            type: "button",
                            name: "btnBanner",
                            class: "button2",
                            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.bannerTouroku && _ctx.bannerTouroku(...args)))
                          }, " バナー登録 "))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isKaunetAdmin && _ctx.isDispOneStopGideKanri)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("fieldset", _hoisted_27, [
                      _hoisted_28,
                      (_ctx.isDispFAQTouroku)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            name: "btnFAQ",
                            class: "button2",
                            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.faqReg && _ctx.faqReg(...args)))
                          }, " FAQ登録 "))
                        : _createCommentVNode("", true),
                      (_ctx.isDispShinseisyoTouroku)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            name: "btnShinseisyo",
                            class: "button2",
                            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.shinseisyoReg && _ctx.shinseisyoReg(...args)))
                          }, " 申請書登録 "))
                        : _createCommentVNode("", true),
                      (_ctx.isDispTeiansyoTouroku)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            name: "btnTeiansyo",
                            class: "button2",
                            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.teiansyoReg && _ctx.teiansyoReg(...args)))
                          }, " 提案書登録 "))
                        : _createCommentVNode("", true),
                      (_ctx.isDispManualTouroku)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            type: "button",
                            name: "btnTyouhyou",
                            class: "button2",
                            onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.manualReg && _ctx.manualReg(...args)))
                          }, " 帳票・マニュアル登録 "))
                        : _createCommentVNode("", true),
                      (_ctx.isDispManualTouroku)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 4,
                            type: "button",
                            name: "btnTyouhyou",
                            class: "button2",
                            onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.oneStopGideKanri && _ctx.oneStopGideKanri(...args)))
                          }, [
                            _createTextVNode(" ワンストップガイド"),
                            _hoisted_29,
                            _createTextVNode("トップ管理 ")
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isKaunetAdmin && _ctx.isDispSkilupKanri)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("fieldset", _hoisted_31, [
                      _hoisted_32,
                      (_ctx.isDispSkilupTouroku)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            name: "btnSkilUp",
                            class: "button2",
                            onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.skilupReg && _ctx.skilupReg(...args)))
                          }, " スキルアップ登録 "))
                        : _createCommentVNode("", true),
                      (_ctx.isDispEventTouroku)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            name: "btnEvent",
                            class: "button2",
                            onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.eventReg && _ctx.eventReg(...args)))
                          }, " イベント登録 "))
                        : _createCommentVNode("", true),
                      (_ctx.isDispEventEntryDL)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            name: "btnEventDownload",
                            class: "button2",
                            onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.eventEntryDL && _ctx.eventEntryDL(...args)))
                          }, [
                            _createTextVNode(" イベント申込み情報"),
                            _hoisted_33,
                            _createTextVNode("ダウンロード ")
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ])
  ], 64))
}